import { IntlProvider } from 'react-intl'
import { useConfig } from '../config'
import YupConfig from './yup-config'

export const onIntlError = (err) => {
	if (err.code === 'MISSING_TRANSLATION' && process.env.NODE_ENV === 'production') return
	if (err.code === 'MISSING_TRANSLATION') {
		console.warn(err.message)
		return
	}
	console.error(err.message)
}

const Provider = ({ children, locale: _locale, translations }) => {
	const { locale: configLocale } = useConfig()
	const locale = _locale ?? configLocale
	return (
		<IntlProvider messages={translations} locale={locale || 'en-US'} defaultLocale="en-US" onError={onIntlError}>
			<YupConfig />
			{children}
		</IntlProvider>
	)
}

export default Provider
